import React, { useState, useEffect } from "react";

/**
 * Branded wordmark reveal shown once per browser session on first load.
 * CSS handles the entrance + fade-out; we unmount after the animation ends.
 */
export default function Preloader() {
  const [show, setShow] = useState(() => {
    try {
      return !sessionStorage.getItem("ddai_seen_loader");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!show) return;
    try {
      sessionStorage.setItem("ddai_seen_loader", "1");
    } catch {
      // ignore storage errors
    }
    const t = setTimeout(() => setShow(false), 2600);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;

  return (
    <div className="preloader" data-testid="preloader" aria-hidden="true">
      <div className="preloader-word text-center relative">
        <span
          className="font-comfortaa font-light text-white text-2xl md:text-4xl"
          style={{ letterSpacing: "0.28em" }}
        >
          DAVIDDOESAI
        </span>
        <span className="font-script text-[#c56b7c] text-3xl md:text-[42px] block leading-none -mt-1 rotate-[-4deg] text-right pr-1">
          studio
        </span>
      </div>
    </div>
  );
}
